import { useCallback } from 'react';
import { getTierIntersectionForFeature } from 'marketplace-ui-apps-core/installability/utils/featureCompatibilities';
import { useDetailsPageContext } from '../context/DetailsPageContext';
import { CompatibilityModal } from './CompatibilityModal';
import { jsx as _jsx } from "react/jsx-runtime";
export function FeatureCompatibilityModal({
  installability,
  features,
  onClose
}) {
  const {
    appContext,
    productType,
    trackInteraction
  } = useDetailsPageContext();
  const featuresWithTierCompatibility = features.map(feature => {
    var _installability$featu;
    const featureCompatibility = installability === null || installability === void 0 || (_installability$featu = installability.featureCompatibilities) === null || _installability$featu === void 0 ? void 0 : _installability$featu.find(compat => compat.featureId === feature.id);
    const tierIntersectionForFeature = getTierIntersectionForFeature(feature, featureCompatibility);
    return {
      text: feature.title,
      tiers: tierIntersectionForFeature
    };
  });
  const handleTrackInteraction = useCallback(eventProps => {
    trackInteraction(Object.assign({
      section: 'feature compatibility modal'
    }, eventProps));
  }, [trackInteraction]);
  return /*#__PURE__*/_jsx(CompatibilityModal, {
    appContext: appContext === 'app' ? 'app' : 'public',
    featuresWithTierCompatibility: featuresWithTierCompatibility,
    onClose: onClose,
    portalTiers: (installability === null || installability === void 0 ? void 0 : installability.portalTiers) || [],
    productType: productType,
    onTrackInteraction: handleTrackInteraction
  });
}